import React from 'react';
//import presentIcon from 'Assets/present-icon.png'
import presentImg from 'Assets/present-img.svg';
// import playBtn from 'Assets/play-btn.png';
import gold_star from 'Assets/new_gold_star.svg';
import './style.css';
//import Collapse from 'react-bootstrap/Collapse';
import { Link, withRouter } from "react-router-dom";
//import { Card, Accordion, Row, Col } from 'react-bootstrap';
import { Row, Col } from 'react-bootstrap';
import { local_routes } from 'utils/Routes';
// import { assembleNickname, getRelativeTime } from 'utils/Helper';
// import avatar from 'Assets/avatarnew.svg';
import ReactTooltip from 'react-tooltip';

import { org_friendly_url } from 'Api/Api';

import group_default_image from 'Assets/group_default_cropped.jpg';

/*
const convrt = n => { 
            if (n < 1e3) return n; 
            if (n >= 1e3 && n < 1e6) return +(n / 1e3).toFixed(1) + "K"; 
            if (n >= 1e6 && n < 1e9) return +(n / 1e6).toFixed(1) + "M"; 
            if (n >= 1e9 && n < 1e12) return +(n / 1e9).toFixed(1) + "B"; 
            if (n >= 1e12) return +(n / 1e12).toFixed(1) + "T"; 
};
*/

class GroupCard extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      adjusted_image_url: '',
      group_link: '',
      truncated_description: '',
      //presenter_info: {},
      //view_count_converted: '0'
    };

    this.workspace_base_url = "";
    if (org_friendly_url) {
      this.workspace_base_url = local_routes.workspace+"/"+org_friendly_url;
    }
    
    /*
    if (props.presentation_info.view_count) {
      this.state.view_count_converted = convrt(props.presentation_info.view_count);
    }
    */
    
    if (props.group_info.friendly_url) {
      this.state.group_link = this.workspace_base_url+local_routes.groups+'/'+props.group_info.friendly_url;
    }
    
    if (props.group_info.image_url) {
      let array = props.group_info.image_url.split("/");
      let pad_color = 'black';
      //if (props.presentation_info.pad_color) {
      //  pad_color = props.presentation_info.pad_color;
      //}
      this.state.adjusted_image_url = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/pad${pad_color}_640x360/${array[5]}`;
      //this.state.adjusted_image_url = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/640x360/${array[5]}`;
    } else {
      this.state.adjusted_image_url = group_default_image;
    }
    
    if (props.group_info['description']) {
      this.state.truncated_description = props.group_info['description'].replace(/(<([^>]+)>)/ig,"").replace(/\&nbsp;/g, '').replace(/\&ndash;/g, '').substring(0, 110);
      if (props.group_info['description'].length !== this.state.truncated_description.length) {
        this.state.truncated_description += "...";
      }
    }
    
    /*
    if (props.presentation_info.users && props.presentation_info.users.length > 0) {
      this.state.presenter_info = props.presentation_info.users[0];
      this.state.presenter_info.nickname = assembleNickname(this.state.presenter_info);
      if (this.state.presenter_info.avatar_image_url) {
        let array = this.state.presenter_info.avatar_image_url.split("/");
        this.state.presenter_info.adjusted_image_url = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/circle_50x50/${array[5]}`;
      }
      if (this.state.presenter_info.friendly_url) {
        this.state.presenter_info.profile_link = this.workspace_base_url+local_routes.users+'/'+this.state.presenter_info.friendly_url;
      }
    }
    */
  }


  
  render() {
    
    return (
      <div className="present-block present-card">
        <div className="present-img">
          <Link to={this.state.group_link}>
            {this.props.group_info.me_in_group &&
              <div className="member-badge"><img width="40px" height="40px" data-tip="You are a member of this group" src={gold_star} alt="img" className="img-fluid" /></div>
            }
            <img src={this.state.adjusted_image_url || presentImg} alt="img" className="img-fluid thumbnail-img" />
          </Link>
        </div>
        <div className="present-pop present-card-pop" style={{ marginTop: "-200px !important", float: "top" }}>
          <Row noGutters={true} className="justify-content-start">
            <Col xs={12}>
              <Link data-place="bottom" data-tip={this.props.group_info.entity_name} to={this.state.group_link}>
                <h4 className="line-clamp-2" style={{ marginTop: "-5px", lineHeight: "1.3" }}>{this.props.group_info.entity_name}</h4>
              </Link>
            </Col>
          </Row>
          <Row noGutters={true} className="justify-content-start">
            <Col xs={12}>
              <Link style={{ fontSize: "smaller", color: "#333333" }} to={this.state.group_link}>
                <span>{this.state.truncated_description}</span>
              </Link>
            </Col>
          </Row>
        </div>
        <ReactTooltip/>
      </div>
    );
  }
  
}
export default withRouter(GroupCard);